import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessVentaAnual } from '../utils/gestionCampanaAccess'

/** Acceso a Venta anual (mismo correo de Control de gestión). */
const RequireVentaAnualAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessVentaAnual(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireVentaAnualAccess
